import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import i18n from './plugins/i18n'

const app = createApp(App)

app.provide('apiBase', window.app.dealersearch_list.api_base)
app.provide('detailListingBase', window.app.dealersearch_list.detail_listing_base)

app.use(store)
app.use(i18n)

/*
* Temporary Config Required
*
* In order to make injections reactively linked to the provider,
* we need to provide a computed property using the computed() function.
* The usage requires setting app.config.unwrapInjectedRef = true to make
* injections automatically unwrap computed refs. This will become the default
* behavior in Vue 3.3 and this config is introduced temporarily to avoid breakage.
* It will no longer be required after 3.3.
*/
app.config.unwrapInjectedRef = true

app.mount('#tx-dealersearch-list')
